import { render, staticRenderFns } from "./releaseDemandDebtDetail.vue?vue&type=template&id=c89cfcec&scoped=true&"
import script from "./releaseDemandDebtDetail.vue?vue&type=script&lang=js&"
export * from "./releaseDemandDebtDetail.vue?vue&type=script&lang=js&"
import style0 from "./releaseDemandDebtDetail.vue?vue&type=style&index=0&id=c89cfcec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89cfcec",
  null
  
)

export default component.exports